import { Methods } from "src/models/Http";

export const http = async (
  method: Methods,
  url: string,
  data: {} | null = null,
  noCache = false
) => {
  let options: {} = {
    method,
    headers: {
      "Cache-Control": noCache ? "no-cache" : "private",
      "Content-Type": "application/json",
      Accept: "application/pdf",
      KudosAuthToken: localStorage.getItem("KudosAuthToken"),
    },
  };

  if (data) {
    options = {
      body: JSON.stringify(data),
      ...options,
    };
  }

  try {
    const fetchData = await fetch(url, options);
    const contentType = fetchData.headers.get("content-type");

    if (fetchData.status === 204) {
      return null;
    }

    if (contentType === "application/pdf") {
      return fetchData.blob();
    } else {
      return fetchData.json();
    }
  } catch (e) {
    throw { message: "Network error", status: 500 };
  }
};

export const getRequest = async (url: string, noCache?: boolean) => {
  return await http("GET", url, null, noCache);
};

export const deleteRequest = async (url: string, noCache?: boolean) => {
  return await http("DELETE", url, null, noCache);
};

export const postRequest = async (url: string, data: {}, noCache?: boolean) => {
  return await http("POST", url, data, noCache);
};

export const putRequest = async (url: string, data: {}, noCache?: boolean) => {
  return await http("PUT", url, data, noCache);
};
